<template>
    <div class="container" />
</template>
<script setup>
import { getTWIDResult } from '@/apis/twid';
import { useRouter } from 'vue-router';
import routeName from '@/router/constant.js';
const router = useRouter();

// 接續頁面
getTWIDResult().then((res) => {
    let page = '';
    if (res.data.result === 'Y') {
        page = routeName.PAYACC_POLICY;
    } else {
        page = routeName.TWID_FAILURE;
    }
    router.push({ name: page });
});
</script>
<style lang="postcss" scoped></style>
